module.exports = __webpack_public_path__ + "img/2.e423b8b9.jpg";